import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  // eslint-disable-next-line no-process-env
  gtmId: process.env.GTM_ID,
}

export const initialize = () => {
  TagManager.initialize(tagManagerArgs)
}
